import StyleVariables from '@components/Gui/StyleVariables';

const useAreaAccentColor = () => {
    return {
        mainColor: StyleVariables.PrimaryColor,
        lightColor: StyleVariables.PrimaryColorLight,
    };
};

export default useAreaAccentColor;
